<template>
<b-container>
    <b-row>
        <b-col cols="">
            <b-card no-body border-variant="msstream" class="marginal">
                <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
                    <h5>Direct Stream</h5>
                </b-card-header>
                <b-card-body>
                    <b-row class="justify-content-around">
                      <b-col sm="6" cols="12">
                        <b-form @submit.prevent="">
                          <b-form-group
                                  id="input-group-1"
                                  label="Stream name"
                                  label-for="input-1"
                                  description="Name of the stream"
                                  :state="validation"
                                  :validated="validation"
                                  invalid-feedback="Please remove spaces and special characters"
                                >
                                  <b-form-input
                                    id="input-1"
                                    v-model="roomID"
                                    type="text"
                                    placeholder="Enter stream name"
                                    required
                                    :disabled="testOpened"
                                  ></b-form-input>
                                </b-form-group>
                        </b-form>
                      </b-col>
                      <b-col sm="5" cols="10" class="mypanel">
                        <h6>Direct link 
                          <b-button variant="msstreamblue" @click="copyToClipboard(directLink)">
                            <font-awesome-icon icon="clone"></font-awesome-icon> Copy</b-button>
                        </h6>
                        <code ref="directLink" style="color:#ba0000">{{directLink}}</code>
                        <h6 class="marginaltopsm">Integrate the player to your website 
                          <b-button variant="msstreamblue" @click="copyToClipboard(iframe)">
                            <font-awesome-icon icon="clone"></font-awesome-icon> Copy</b-button>
                        </h6>
                        <code ref="integratedPlayer" style="color:#ba0000">{{iframe}}</code>
                      </b-col>
                    </b-row>
                    <b-row class="justify-content-center marginaltop" v-if="!testOpened">
                      <b-col cols="auto">
                        <a :href="'/#/delivery/' + roomID" v-if="validation"><b-btn variant="msstreamblue">Start stream</b-btn></a>
                        <b-btn v-if="!validation" variant="msstreamblue" disabled>Start stream</b-btn>
                      </b-col>
                      <b-col cols="auto">
                        <b-btn v-if="validation" variant="msstreamblue" @click="testOpened = true">Start stream (in this page)</b-btn>
                        <b-btn v-if="!validation" variant="msstreamblue" disabled>Start stream (in this page)</b-btn>
                      </b-col>
                    </b-row>

                    <b-row class="justify-content-center marginaltop" v-if="testOpened">
                      <b-col cols="auto">
                        <b-btn variant="quanteec" @click="testOpened = false">Close current stream</b-btn>
                      </b-col>
                    </b-row>

                    <b-row class="justify-content-center marginaltop" v-if="testOpened">
                      <b-col lg="6" md="6" sm="10" cols="12">
                        <b-row class="justify-content-center">
                          <h5>Video source (what you send to other people)</h5>
                        </b-row>
                        <b-row>
                          <b-col cols="12">
                            <div class="videoContainer">
                              <iframe id="video-player" style="width:100%;height:100%;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" frameBorder="0" scrolling="no" :src="'/#/delivery/' + roomID"></iframe>
                            </div>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col lg="6" md="6" sm="10" cols="12">
                        <b-row class="justify-content-center">
                          <h5>Video Received (what other people see)</h5>
                        </b-row>
                        <b-row>
                          <b-col cols="12">
                            <div class="videoContainer">
                              <iframe id="video-player2" style="width:100%;height:100%;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" frameBorder="0" scrolling="no" :src="directLink + '&audio=0'"></iframe>
                            </div>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                </b-card-body>
            </b-card>
        </b-col>
    </b-row>

  <b-modal ref="copied" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Copied</h3>
      </div>
      <p>Link copied</p>
      <b-row class="justify-content-around">
          <b-btn class="col-md-3 col-5" variant="msstreamblue" block @click="cleanMyTimeout();hideModal('copied')">Ok</b-btn>
      </b-row>
  </b-modal>

  </b-container>
</template>

<script>
import {BASE_URL} from '@/services/base-url'

export default {
  name: 'exportLink',
  data: function() {
    return {
      clientView: (this.$auth.getMyUser().roles.indexOf('admin') > -1) ? this.$auth.getMyClientView() || this.$auth.getMyUser().client : this.$auth.getMyUser().client,
      roomID: '',
      timeout: null,
      testOpened: false,
    }
  },
  computed: {
    directLink() {
      return `${BASE_URL}/directstream/embeded.html?uuid=${this.roomID}`
    },
    iframe() {
      return `<iframe id="video-player" style="width:100%;height:100%" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" frameBorder="0" scrolling="no" src="${this.directLink}"></iframe>`;
    },
    validation() {
      let format = /[ ²`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      return !(format.test(this.roomID))//this.roomID.match(/^[^a-zA-Z0-9]+$/g) ? true : false;
    },
  },
  mounted: function() {
      window.addEventListener('message', (e) => {
      // Get the sent data
        const data = e.data;
        if(data === "closePreview")
          this.testOpened = false;
      });


    this.roomID = this.clientView;
  },
  methods: {
    cleanMyTimeout() {
      try {
        clearTimeout(this.timeout);
      } catch(err) {}
    },
    copyToClipboard(text) {
      this.cleanMyTimeout();
      this.$copyText(text);
      this.showModal("copied");
      this.timeout = setTimeout(this.hideModal, 0.8 * 1000, 'copied');
    },
    showModal(modalRef) {
      this.$refs[modalRef].show();
    },
    hideModal(modalRef) {
      this.$refs[modalRef].hide();
    },
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.resp-container {
  width: 100%;
  padding-top: 56.25%;
  border: 1px solid;
  border-color: lightgrey;
  border-radius: 5px;
  position: relative;
}
.resp-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.oldcard {
    border: 5px dashed #ba0000;
  }

  .marginalsmall {
    margin-top: 10px;
    margin-bottom: 10px;
  }

.videoContainer {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  background-color: black;
}
</style>
